import { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
// import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import BlogSection from '../../components/BlogSection/BlogSection';
import ZohoContactForm from '../../components/ZohoContactForm/ZohoContactForm';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg'

const HomePage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'}  Logo={Logo} />
            <Hero hclass={'static-hero'} />
            {/* <About hclass={'about_section section-padding'}/> */}
            <ServiceSection hclass={"service_section section-padding"} />
            <Testimonial tClass={'testimonial_section testimonial_section_slider'} />
            <BlogSection tClass={'blog_section section-padding'}/>
            <section className="section-padding">
                <div className="container">
                    <ZohoContactForm variant="homepage" />
                </div>
            </section>
            <Footer hclass={'wpo-site-footer'}/>
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage;